import { useLogoutMutation as e } from "../queries/login/useLogoutMutation.mjs";
import { useLocalStorage as t } from "@maat/hooks";
//#region src/hooks/useLogout.ts
var n = (n) => {
	let r = e(), [, i] = t("auth:hasSession", !1);
	return {
		logout: async () => {
			await r.mutateAsync(void 0), i(!1), n?.onLoggedOut?.();
		},
		isPending: r.isPending,
		error: r.error,
		reset: r.reset
	};
};
//#endregion
export { n as useLogout };
